import InfoTable from './InfoTable';

export default InfoTable;
